import profile from "../../assets/img/aboutmeimage.png";
import pythonLogo from "../../assets/img/python-logo.png";
import { FaCss3 } from "react-icons/fa";
import { SiNextdotjs } from "react-icons/si";
import { TbBrandJavascript } from "react-icons/tb";
import { FaReact } from "react-icons/fa";
import { SiTailwindcss } from "react-icons/si";
import { BsBootstrapFill } from "react-icons/bs";
import { SiFastapi } from "react-icons/si";
import { FaHtml5 } from "react-icons/fa";

const Intro = () => {
    return (
      <div className="flex flex-col items-center justify-center w-full pt-20 pb-28 text-white bg-[white] ">
            <div className="w-[96%] xl:w-[90%] gap-x-10 flex flex-col gap-y-10 lg:flex-row items-center justify-between">
                {/* left */}
                <div
                    className="flex flex-col justify-center w-full gap-y-5 lg:gap-y-6 md:w-auto"
                    // data-aos="flip-right"
                    // data-aos-offset="100"
                    // data-aos-delay="600"
                >
                    <div className="">
                        <h5 className="text-[28px] uppercase lg:text-[35px] xl:text-[45px] font-extrabold text-[#373737]  ">
                        Gulfam Haider
                        </h5>
                        <p className="text-sm md:text-[16px] text-[#303030]">THOUGHT LEADER, TECH ENTREPRENEUR, FREELANCER</p>
                        {/* <img src={gif} alt="" className='relative bottom-4' /> */}
                    </div>
                  <div className="flex flex-col justify-center gap-y-5 lg:max-w-[95%] xl:max-w-[85%] text-[#303030] text-sm md:text-[16px]">
                    
                    <p className="">I am an “industry-experienced web developer” to my clients, a “helpful senior” to many, and a “programming genius” to most.</p>
                    <div className="flex flex-wrap items-center">
                      <p>For <span className="font-semibold uppercase">my clients</span>, I am a front-end developer skilled in</p>
                      <div className="flex items-center gap-x-1">( <SiNextdotjs
                                        size={22}
                                        title="Next.js"
                                        className="text-black"
                                    />
                                    <FaReact
                                        size={23}
                                        title="React.js"
                                        className="text-[#006C96]"
                                    />
                                    <TbBrandJavascript
                                        size={24}
                                        title="Javascript"
                                        className="text-[#F3E159]"
                                    />
                                    
                                    <FaHtml5
                                        size={23}
                                        title="HTML"
                                        className="text-[#F75F2A]"
                                    />
                                    <FaCss3
                                        size={22}
                                        title="CSS"
                                        className="text-[#2862E9]"
                                    />
                                    <SiTailwindcss
                                        size={23}
                                        title="TailwindCSS"
                                        className="text-[#36B7F0]"
                                    />
                                    <BsBootstrapFill
                                        size={22}
                                        title="Bootstrap"
                                        className="text-[#7710F1]"
                                    />
                                    
                                    )</div> <p>and a backend developer skilled in</p> <div className="flex items-center gap-x-1">(<img
                                      src={pythonLogo}
                                      alt=""
                                      title="Python"
                                      className="h-[24px]"
                                  />
                                  <SiFastapi
                                      size={22}
                                      title="FastAPI"
                                      className="text-[#059286]"
                                  />)</div>.</div>
                    
                    <p>For <span className="font-semibold uppercase">my juniors</span>, I am a worthy senior, programming tutor, and tech guide. I strive to be the senior I needed when I was a junior, providing assistance and free training. I share tech industry knowledge and offer guidance on their programming journey. Currently, I am helping over 10 individuals learn web development and have assisted more than 4 people in entering the tech industry through internships.</p>
                    
                    <p>I am someone who enjoys solving problems and finding, fixing bugs. I have always loved computers and games, that's why I got into programming. When I entered the world of programming, I got a strong connection with it, and it granted me another identity – that of a 'topper'. I achieved top positions in my university, received highest scores for the extraordinary and unique projects, and created interesting projects that earned me the title of <span className="font-semibold uppercase">“Programming genius”</span>. Now, I am recognized as a reliable problem-solver and a go-to person for technical challenges.</p>
                    
                  </div>
                   
                </div>

                {/* right */}
                <img
                    src={profile}
                    alt=""
                    className=" w-full lg:h-[450px] xl:h-[502px] shadow-md object-cover rounded-md shadow-black"
                />
            </div>
        </div>
    );
};

export default Intro;
